import { Col, Progress, Row, Text } from 'ui';
import { useGetFormProgress } from '../../hooks';
import type { ProfileFormValues } from '../ProfileForm';

type P = {
  values: Partial<ProfileFormValues>;
};

const ProgressBar = ({ values }: P) => {
  const getProgress = useGetFormProgress();
  const { color, percentage } = getProgress({ values });

  return (
    <>
      <Progress color={color} percent={percentage} showInfo={false} size="extra-small" />
      <Row justify="space-between">
        <Col>
          <Text size="small">Profile completeness</Text>
        </Col>
        <Col>
          <Text size="small">{percentage}%</Text>
        </Col>
      </Row>
    </>
  );
};

export default ProgressBar;
